/**
 * Shared Altru URL constants for use in frontend components.
 * All values are derived from NEXT_PUBLIC_ALTRU_BASE_URL.
 */

/** Altru membership page — used for upgrade, renew, and start-membership CTAs. */
export const ALTRU_MEMBERSHIP_URL = `${process.env.NEXT_PUBLIC_ALTRU_BASE_URL ?? ""}/Membership`;
